export interface MediaQueryConfig {
  minWidth?: string;
  maxWidth?: string;
  minAspectRatio?: string;
  maxAspectRatio?: string;
}

export const buildMediaQuery = ({
  minWidth,
  maxWidth,
  minAspectRatio,
  maxAspectRatio,
}: MediaQueryConfig): string => {
  const queries = [
    minWidth && `(min-width: calc(${minWidth} + 1px))`,
    maxWidth && `(max-width: ${maxWidth})`,
    minAspectRatio && `(min-aspect-ratio: ${minAspectRatio})`,
    maxAspectRatio && `(max-aspect-ratio: ${maxAspectRatio})`,
  ];

  return queries.filter((query) => query).join(" and ");
};
